export interface ImportJob {
  id: string;
  fileName: string;
  fileSize?: number;
  totalRows: number;
  processedRows: number;
  successCount: number;
  errorCount: number;
  status: ImportStatus;
  createdDate: string;
  startedDate?: string;
  completedDate?: string;
  estimatedTimeRemaining?: number;
  errorReportUrl?: string;
  createdBy?: string;
}

export type ImportStatus = 'Pending' | 'Processing' | 'Completed' | 'Failed' | 'Cancelled';

export const ImportStatus = {
  Pending: 'Pending' as const,
  Processing: 'Processing' as const,
  Completed: 'Completed' as const,
  Failed: 'Failed' as const,
  Cancelled: 'Cancelled' as const,
};

export interface ImportProgress {
  jobId: string;
  totalRows: number;
  processedRows: number;
  successCount: number;
  errorCount: number;
  status: ImportStatus;
  estimatedTimeRemaining?: number;
}

export interface ImportSummary {
  jobId: string;
  fileName: string;
  totalRows: number;
  successCount: number;
  errorCount: number;
  status: ImportStatus;
  createdDate: string;
  startedDate?: string;
  completedDate?: string;
  duration?: number;
  errorReportUrl?: string;
  errors?: Array<{
    rowNumber: number;
    field: string;
    errorMessage: string;
    rowData?: string;
  }>;
}

export interface TemplateField {
  name: string;
  description: string;
  required: boolean;
  example: string;
  group: string;
}

export interface ImportTemplate {
  fields: TemplateField[];
  sampleData: Record<string, string>[];
}

export interface ImportError {
  row: number;
  field: string;
  value: string;
  error: string;
}

export interface ImportValidationResult {
  isValid: boolean;
  errors: ImportError[];
  warnings: ImportError[];
}

export interface ImportJobsResponse {
  jobs: ImportJob[];
  total: number;
  active: number;
  completed: number;
  failed: number;
}

export interface AssetFieldDefinition {
  field: string;
  label: string;
  description: string;
  isRequired: boolean;
  dataType: 'string' | 'number' | 'date' | 'select';
  example: string;
  group: string;
  options?: string[];
}
